// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions } from '../duck';
import SearchStep from '../components/SearchStep';

import type { RootState } from '../../..';
import { push } from 'react-router-redux';

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale,
    authenticated: state.auth.authenticated,
    localeState: state.locale,
    localValues: state.localValues,
    isFetchingProducts: state.newOrder.searchStep.isFetchingProducts,
    products: state.newOrder.searchStep.products,
    fetchProductError: state.newOrder.searchStep.fetchProductsError,
    page: state.newOrder.searchStep.page,
    pageCanAsk: state.newOrder.searchStep.pageCanAsk,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...actions,
    goToRedirect: (route: string) => push(route),
    changeQuery: (queryParams: string) => push({
      search: queryParams,
    }),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchStep);



// WEBPACK FOOTER //
// ./src/modules/new-order/SearchStep/containers/SearchStepContainer.jsx